module.exports = __webpack_public_path__ + "static/img/blueegg.7b12a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/blueegg.png
// module id = 3viZ
// module chunks = 1